import * as React from "react";
import { useEffect, useState } from "react";
import { SelectOptionType } from "react-select";
import useCommonListFunctions from "../../../hooks/useCommonList/useCommonListFunctions";
import { PartnerStatusList, PartnerStatusLabelMap } from "../../../../models/Partner";
// Dựng thẳng từ PartnerStatusList: thêm trạng thái mới chỉ phải sửa MỘT chỗ (models/Partner.ts).
// Bản cũ liệt kê tay 3 mục nên khi server biết thêm `banned` thì ô lọc vẫn mù.
export const userStatusList: SelectOptionType[] = PartnerStatusList.map((st) => ({
	label: PartnerStatusLabelMap.get(st) || "",
	value: st.toString(),
	object: "",
}));

export function useStatusFilter() {
	const { filterStates, doFilterStates } = useCommonListFunctions();
	const initialStatus = filterStates ? filterStates.toString() : "";
	const [statusSelected, setStatusSelected] = useState<SelectOptionType>(
		() => userStatusList.find((item) => item.value === initialStatus) || userStatusList[0]
	);

	const handleFilter = (value: string) => {
		setStatusSelected(userStatusList.find((item) => item.value === value) || userStatusList[0]);
		if (doFilterStates) {
			doFilterStates(value);
		}
	};

	return { statusSelected, handleFilter };
}
